import type {Request} from 'express'

export const ANDROID_APP_USER_AGENT = 'Mozilla/5.0 (Linux; U; Android 2.2.1; en-us; Nexus One Build/FRG83) AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1'
export const IPHONE_APP_USER_AGENT = 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_6_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile'
export const IPAD_APP_USER_AGENT = 'Mozilla/5.0 (iPad; U; CPU OS 4_3_2 like Mac OS X; en-us) AppleWebKit/533.17.9 (KHTML, like Gecko) Mobile'
export const TABLET_APP_USER_AGENT = 'Mozilla/5.0 (Linux; Android 12; SM-X906C Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/80.0.3987.119 Mobile Safari/537.36'

export const isUserOnMobile = (req: Request): boolean => {
    const userAgent = req.headers['user-agent']

    const mobileUserAgents = [IPHONE_APP_USER_AGENT, IPAD_APP_USER_AGENT, TABLET_APP_USER_AGENT, ANDROID_APP_USER_AGENT]
    const isMobile = mobileUserAgents.includes(userAgent || '') || req.get('referer')?.includes('/mobile')
    return isMobile ?? false
}
